
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google'; 
import Sidebar from './components/sidebar';
import MainPage from './components/main-page';
import Recipes from './pages/recipes';
import Papers from './pages/papers';
import ProtectedRoute from './components/auth/protectedRoute';
import NotFound from './components/auth/notFound';
import WorkoutGenerator from './components/utilities/workout/generator';
import SupplementOptimizer from './components/utilities/supplements/optimizer';
import FoodAnalyzer from './components/utilities/food/analyzer';
import BioMarkers from './pages/biomarkers';
import Header from './components/layout/header';
import Footer from './components/layout/footer';
import PrivacyPolicy from './pages/legal/privacy';
import TermsAndConditions from './pages/legal/terms';
import About from './pages/about';
import ProfilePage from './components/profile';

// Handle hash navigation for MainPage
const MainPageWithHash = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.hash]);

  return <MainPage />;
};

// Wrapper to reset and render MainPage properly
const MainPageWrapper = () => {
  const location = useLocation();

  if (location.hash && location.pathname !== '/') {
    return <Navigate to={`/${location.hash}`} replace />;
  }

  // Add a key prop to force re-render on `/`
  return <MainPageWithHash key={location.key} />;
};

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <div className="app">
          <div className="content-wrapper">
            <Sidebar />
            {/* <Header /> */}
            <main className="main-content">
              <Routes>
                <Route
                  path="/utilities/workout/generator"
                  element={
                    <ProtectedRoute>
                      <WorkoutGenerator />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/utilities/food/analyzer"
                  element={
                    <ProtectedRoute>
                      <FoodAnalyzer />
                    </ProtectedRoute>
                  }
                />
                                <Route
                  path="/utilities/supplements/optimizer"
                  element={
                    <ProtectedRoute>
                      <SupplementOptimizer />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/biomarkers"
                  element={
                    <ProtectedRoute>
                      <BioMarkers />
                    </ProtectedRoute>
                  }
                />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/papers" element={<Papers />} />
                <Route path="/about" element={<About />} />
                <Route path="/profile" element={
                    <div>
                      <ProfilePage />
                    </div>
                  }
                />
                <Route path="/legal/privacy" element={<PrivacyPolicy />} />
                <Route path="/legal/terms" element={<TermsAndConditions />} />
                <Route path="/workout/generator" element={<WorkoutGenerator />} />
                <Route path="/" element={<MainPageWrapper />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;


